import { getThemeColor } from "./colors";
export var themeConfig = function themeConfig(isDarkMode) {
  var _getThemeColor = getThemeColor(isDarkMode),
    type = _getThemeColor.type,
    colorBlue = _getThemeColor.colorBlue,
    colorGreen = _getThemeColor.colorGreen,
    colorOrange = _getThemeColor.colorOrange,
    colorRed = _getThemeColor.colorRed,
    colorText = _getThemeColor.colorText,
    colorTextSecondary = _getThemeColor.colorTextSecondary,
    colorTextTertiary = _getThemeColor.colorTextTertiary;
  return {
    name: type,
    type: type,
    semanticHighlighting: true,
    semanticTokenColors: {
      enumMember: {
        foreground: colorBlue
      },
      'variable.constant': {
        foreground: colorGreen
      },
      'variable.defaultLibrary': {
        foreground: colorRed
      },
      'variable:dart': {
        foreground: colorGreen
      },
      'property:dart': {
        foreground: colorGreen
      },
      'annotation:dart': {
        foreground: colorGreen
      },
      'parameter.label:dart': {
        foreground: colorTextTertiary
      },
      macro: {
        foreground: colorGreen
      },
      tomlArrayKey: {
        foreground: colorRed
      }
    },
    tokenColors: [{
      scope: 'meta.embedded',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'unison punctuation',
      scope: 'punctuation.definition.delayed.unison,punctuation.definition.list.begin.unison,punctuation.definition.list.end.unison,punctuation.definition.ability.begin.unison,punctuation.definition.ability.end.unison,punctuation.operator.assignment.as.unison,punctuation.separator.pipe.unison,punctuation.separator.delimiter.unison,punctuation.definition.hash.unison',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'haskell variable generic-type',
      scope: 'variable.other.generic-type.haskell',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'haskell storage type',
      scope: 'storage.type.haskell',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'support.variable.magic.python',
      scope: 'support.variable.magic.python',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'punctuation.separator.parameters.python',
      scope: 'punctuation.separator.period.python,punctuation.separator.element.python,punctuation.parenthesis.begin.python,punctuation.parenthesis.end.python',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'variable.parameter.function.language.special.self.python',
      scope: 'variable.parameter.function.language.special.self.python',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'variable.parameter.function.language.special.cls.python',
      scope: 'variable.parameter.function.language.special.cls.python',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'storage.modifier.lifetime.rust',
      scope: 'storage.modifier.lifetime.rust',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'support.function.std.rust',
      scope: 'support.function.std.rust',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'entity.name.lifetime.rust',
      scope: 'entity.name.lifetime.rust',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'variable.language.rust',
      scope: 'variable.language.rust',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'support.constant.edge',
      scope: 'support.constant.edge',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'regexp constant character-class',
      scope: 'constant.other.character-class.regexp',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'keyword.operator',
      scope: ['keyword.operator.word'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'regexp operator.quantifier',
      scope: 'keyword.operator.quantifier.regexp',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Text',
      scope: 'variable.parameter.function',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Comment Markup Link',
      scope: 'comment markup.link',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'markup diff',
      scope: 'markup.changed.diff',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'diff',
      scope: 'meta.diff.header.from-file,meta.diff.header.to-file,punctuation.definition.from-file.diff,punctuation.definition.to-file.diff',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'inserted.diff',
      scope: 'markup.inserted.diff',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'deleted.diff',
      scope: 'markup.deleted.diff',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'c++ function',
      scope: 'meta.function.c,meta.function.cpp',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'c++ block',
      scope: 'punctuation.section.block.begin.bracket.curly.cpp,punctuation.section.block.end.bracket.curly.cpp,punctuation.terminator.statement.c,punctuation.section.block.begin.bracket.curly.c,punctuation.section.block.end.bracket.curly.c,punctuation.section.parens.begin.bracket.round.c,punctuation.section.parens.end.bracket.round.c,punctuation.section.parameters.begin.bracket.round.c,punctuation.section.parameters.end.bracket.round.c',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'js/ts punctuation separator key-value',
      scope: 'punctuation.separator.key-value',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'js/ts import keyword',
      scope: 'keyword.operator.expression.import',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'math js/ts',
      scope: 'support.constant.math',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'math property js/ts',
      scope: 'support.constant.property.math',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js/ts variable.other.constant',
      scope: 'variable.other.constant',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'java type',
      scope: ['storage.type.annotation.java', 'storage.type.object.array.java'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'java source',
      scope: 'source.java',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'java modifier.import',
      scope: 'punctuation.section.block.begin.java,punctuation.section.block.end.java,punctuation.definition.method-parameters.begin.java,punctuation.definition.method-parameters.end.java,meta.method.identifier.java,punctuation.section.method.begin.java,punctuation.section.method.end.java,punctuation.terminator.java,punctuation.section.class.begin.java,punctuation.section.class.end.java,punctuation.section.inner-class.begin.java,punctuation.section.inner-class.end.java,meta.method-call.java,punctuation.section.class.begin.bracket.curly.java,punctuation.section.class.end.bracket.curly.java,punctuation.section.method.begin.bracket.curly.java,punctuation.section.method.end.bracket.curly.java,punctuation.separator.period.java,punctuation.bracket.angle.java,punctuation.definition.annotation.java,meta.method.body.java',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'java modifier.import',
      scope: 'meta.method.java',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'java modifier.import',
      scope: 'storage.modifier.import.java,storage.type.java,storage.type.generic.java',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'java instanceof',
      scope: 'keyword.operator.instanceof.java',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'java variable.name',
      scope: 'meta.definition.variable.name.java',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'operator logical',
      scope: 'keyword.operator.logical',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'operator bitwise',
      scope: 'keyword.operator.bitwise',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'operator channel',
      scope: 'keyword.operator.channel',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'support.constant.property-value.scss',
      scope: 'support.constant.property-value.scss,support.constant.property-value.css',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'CSS/SCSS/LESS Operators',
      scope: 'keyword.operator.css,keyword.operator.scss,keyword.operator.less',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'css color standard name',
      scope: 'support.constant.color.w3c-standard-color-name.css,support.constant.color.w3c-standard-color-name.scss',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'css comma',
      scope: 'punctuation.separator.list.comma.css',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'css attribute-name.id',
      scope: 'support.constant.color.w3c-standard-color-name.css',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'css property-name',
      scope: 'support.type.vendored.property-name.css',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'js/ts module',
      scope: 'support.module.node,support.type.object.module,support.module.node',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'entity.name.type.module',
      scope: 'entity.name.type.module',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'js variable readwrite',
      scope: 'variable.other.readwrite,meta.object-literal.key,support.variable.property,support.variable.object.process,support.variable.object.node',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'js/ts json',
      scope: 'support.constant.json',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js/ts Keyword',
      scope: ['keyword.operator.expression.instanceof', 'keyword.operator.new', 'keyword.operator.ternary', 'keyword.operator.optional', 'keyword.operator.expression.keyof'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'js/ts console',
      scope: 'support.type.object.console',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'js/ts support.variable.property.process',
      scope: 'support.variable.property.process',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js console function',
      scope: 'entity.name.function,support.function.console',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'keyword.operator.misc.rust',
      scope: 'keyword.operator.misc.rust',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'keyword.operator.sigil.rust',
      scope: 'keyword.operator.sigil.rust',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'operator',
      scope: 'keyword.operator.delete',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'js dom',
      scope: 'support.type.object.dom',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'js dom variable',
      scope: 'support.variable.dom,support.variable.property.dom',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'keyword.operator',
      scope: 'keyword.operator.arithmetic,keyword.operator.comparison,keyword.operator.decrement,keyword.operator.increment,keyword.operator.relational',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'C operator assignment',
      scope: 'keyword.operator.assignment.c,keyword.operator.comparison.c,keyword.operator.c,keyword.operator.increment.c,keyword.operator.decrement.c,keyword.operator.bitwise.shift.c,keyword.operator.assignment.cpp,keyword.operator.comparison.cpp,keyword.operator.cpp,keyword.operator.increment.cpp,keyword.operator.decrement.cpp,keyword.operator.bitwise.shift.cpp',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Punctuation',
      scope: 'punctuation.separator.delimiter',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Other punctuation .c',
      scope: 'punctuation.separator.c,punctuation.separator.cpp',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'C type posix-reserved',
      scope: 'support.type.posix-reserved.c,support.type.posix-reserved.cpp',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'keyword.operator.sizeof.c',
      scope: 'keyword.operator.sizeof.c,keyword.operator.sizeof.cpp',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'python parameter',
      scope: 'variable.parameter.function.language.python',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'python type',
      scope: 'support.type.python',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'python logical',
      scope: 'keyword.operator.logical.python',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'pyCs',
      scope: 'variable.parameter.function.python',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'python block',
      scope: 'punctuation.definition.arguments.begin.python,punctuation.definition.arguments.end.python,punctuation.separator.arguments.python,punctuation.definition.list.begin.python,punctuation.definition.list.end.python',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'python function-call.generic',
      scope: 'meta.function-call.generic.python',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'python placeholder reset to normal string',
      scope: 'constant.character.format.placeholder.other.python',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Operators',
      scope: 'keyword.operator',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Compound Assignment Operators',
      scope: 'keyword.operator.assignment.compound',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Compound Assignment Operators js/ts',
      scope: 'keyword.operator.assignment.compound.js,keyword.operator.assignment.compound.ts',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Keywords',
      scope: 'keyword',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Namespaces',
      scope: 'entity.name.namespace',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Variables',
      scope: 'variable',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Variables',
      scope: 'variable.c',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Language variables',
      scope: 'variable.language',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Java Variables',
      scope: 'token.variable.parameter.java',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Java Imports',
      scope: 'import.storage.java',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Packages',
      scope: 'token.package.keyword',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Packages',
      scope: 'token.package',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Functions',
      scope: ['entity.name.function', 'meta.require', 'support.function.any-method', 'variable.function'],
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'Classes',
      scope: 'entity.name.type.namespace',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Classes',
      scope: 'support.class, entity.name.type.class',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Class name',
      scope: 'entity.name.class.identifier.namespace.type',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Class name',
      scope: ['entity.name.class', 'variable.other.class.js', 'variable.other.class.ts'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Class name php',
      scope: 'variable.other.class.php',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Type Name',
      scope: 'entity.name.type',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Keyword Control',
      scope: 'keyword.control',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Control Elements',
      scope: 'control.elements, keyword.operator.less',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Methods',
      scope: 'keyword.other.special-method',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'Storage',
      scope: 'storage',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Storage JS TS',
      scope: 'token.storage',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Source Js Keyword Operator Delete,source Js Keyword Operator In,source Js Keyword Operator Of,source Js Keyword Operator Instanceof,source Js Keyword Operator New,source Js Keyword Operator Typeof,source Js Keyword Operator Void',
      scope: 'keyword.operator.expression.delete,keyword.operator.expression.in,keyword.operator.expression.of,keyword.operator.expression.instanceof,keyword.operator.new,keyword.operator.expression.typeof,keyword.operator.expression.void',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Java Storage',
      scope: 'token.storage.type.java',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Support',
      scope: 'support.function',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Support type',
      scope: 'support.type.property-name',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: '[VSCODE-CUSTOM] toml support',
      scope: 'support.type.property-name.toml, support.type.property-name.table.toml, support.type.property-name.array.toml',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Support type',
      scope: 'support.constant.property-value',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Support type',
      scope: 'support.constant.font-name',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Meta tag',
      scope: 'meta.tag',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Strings',
      scope: 'string',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Constant other symbol',
      scope: 'constant.other.symbol',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Integers',
      scope: 'constant.numeric',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Constants',
      scope: 'constant',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Constants',
      scope: 'punctuation.definition.constant',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Tags',
      scope: 'entity.name.tag',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Attributes',
      scope: 'entity.other.attribute-name',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Attribute IDs',
      scope: 'entity.other.attribute-name.id',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'Attribute class',
      scope: 'entity.other.attribute-name.class.css',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Selector',
      scope: 'meta.selector',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Headings',
      scope: 'markup.heading',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Headings',
      scope: 'markup.heading punctuation.definition.heading, entity.name.section',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'Units',
      scope: 'keyword.other.unit',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Bold',
      scope: 'markup.bold,todo.bold',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Bold',
      scope: 'punctuation.definition.bold',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'markup Italic',
      scope: 'markup.italic, punctuation.definition.italic,todo.emphasis',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'emphasis md',
      scope: 'emphasis md',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown headings',
      scope: 'entity.name.section.markdown',
      settings: {
        foreground: colorText
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown heading Punctuation Definition',
      scope: 'punctuation.definition.heading.markdown',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'punctuation.definition.list.begin.markdown',
      scope: 'punctuation.definition.list.begin.markdown',
      settings: {
        foreground: colorRed
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown heading setext',
      scope: 'markup.heading.setext',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Punctuation Definition Bold',
      scope: 'punctuation.definition.bold.markdown',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Inline Raw',
      scope: 'markup.inline.raw.markdown',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Inline Raw',
      scope: 'markup.inline.raw.string.markdown',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Inline Raw punctuation',
      scope: 'punctuation.definition.raw.markdown',
      settings: {
        foreground: colorRed
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown List Punctuation Definition',
      scope: 'punctuation.definition.list.markdown',
      settings: {
        foreground: colorRed
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Punctuation Definition String',
      scope: ['punctuation.definition.string.begin.markdown', 'punctuation.definition.string.end.markdown', 'punctuation.definition.metadata.markdown'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'beginning.punctuation.definition.list.markdown',
      scope: ['beginning.punctuation.definition.list.markdown'],
      settings: {
        foreground: colorText
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Punctuation Definition Link',
      scope: 'punctuation.definition.metadata.markdown',
      settings: {
        foreground: colorText
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Underline Link/Image',
      scope: 'markup.underline.link.markdown,markup.underline.link.image.markdown',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Link Title/Description',
      scope: 'string.other.link.title.markdown,string.other.link.description.markdown',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: '[VSCODE-CUSTOM] Asciidoc Inline Raw',
      scope: 'markup.raw.monospace.asciidoc',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: '[VSCODE-CUSTOM] Asciidoc Inline Raw Punctuation Definition',
      scope: 'punctuation.definition.asciidoc',
      settings: {
        foreground: colorRed
      }
    }, {
      name: '[VSCODE-CUSTOM] Asciidoc List Punctuation Definition',
      scope: 'markup.list.asciidoc',
      settings: {
        foreground: colorRed
      }
    }, {
      name: '[VSCODE-CUSTOM] Asciidoc underline link',
      scope: 'markup.link.asciidoc,markup.other.url.asciidoc',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: '[VSCODE-CUSTOM] Asciidoc link name',
      scope: 'string.unquoted.asciidoc,markup.other.url.asciidoc',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'Regular Expressions',
      scope: 'string.regexp',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Embedded',
      scope: 'punctuation.section.embedded, variable.interpolation',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Embedded',
      scope: 'punctuation.section.embedded.begin,punctuation.section.embedded.end',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'illegal',
      scope: 'invalid.illegal',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'illegal',
      scope: 'invalid.illegal.bad-ampersand.html',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      scope: 'invalid.illegal.unrecognized-tag.html',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Broken',
      scope: 'invalid.broken',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Deprecated',
      scope: 'invalid.deprecated',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'html Deprecated',
      scope: 'invalid.deprecated.entity.other.attribute-name.html',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Unimplemented',
      scope: 'invalid.unimplemented',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Source Json Meta Structure Dictionary Json > String Quoted Json',
      scope: 'source.json meta.structure.dictionary.json > string.quoted.json',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Source Json Meta Structure Dictionary Json > String Quoted Json > Punctuation String',
      scope: 'source.json meta.structure.dictionary.json > string.quoted.json > punctuation.string',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Source Json Meta Structure Dictionary Json > Value Json > String Quoted Json,source Json Meta Structure Array Json > Value Json > String Quoted Json,source Json Meta Structure Dictionary Json > Value Json > String Quoted Json > Punctuation,source Json Meta Structure Array Json > Value Json > String Quoted Json > Punctuation',
      scope: 'source.json meta.structure.dictionary.json > value.json > string.quoted.json,source.json meta.structure.array.json > value.json > string.quoted.json,source.json meta.structure.dictionary.json > value.json > string.quoted.json > punctuation,source.json meta.structure.array.json > value.json > string.quoted.json > punctuation',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Source Json Meta Structure Dictionary Json > Constant Language Json,source Json Meta Structure Array Json > Constant Language Json',
      scope: 'source.json meta.structure.dictionary.json > constant.language.json,source.json meta.structure.array.json > constant.language.json',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: '[VSCODE-CUSTOM] JSON Property Name',
      scope: 'support.type.property-name.json',
      settings: {
        foreground: colorText
      }
    }, {
      name: '[VSCODE-CUSTOM] JSON Punctuation for Property Name',
      scope: 'support.type.property-name.json punctuation',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'laravel blade tag',
      scope: 'text.html.laravel-blade source.php.embedded.line.html entity.name.tag.laravel-blade',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'laravel blade @',
      scope: 'text.html.laravel-blade source.php.embedded.line.html support.constant.laravel-blade',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'use statement for other classes',
      scope: 'support.other.namespace.use.php,support.other.namespace.use-as.php,entity.other.alias.php,meta.interface.php',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'error suppression',
      scope: 'keyword.operator.error-control.php',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'php instanceof',
      scope: 'keyword.operator.type.php',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'style double quoted array index normal begin',
      scope: 'punctuation.section.array.begin.php',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'style double quoted array index normal end',
      scope: 'punctuation.section.array.end.php',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'php illegal.non-null-typehinted',
      scope: 'invalid.illegal.non-null-typehinted.php',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'php types',
      scope: 'storage.type.php,meta.other.type.phpdoc.php,keyword.other.type.php,keyword.other.array.phpdoc.php',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'php call-function',
      scope: 'meta.function-call.php,meta.function-call.object.php,meta.function-call.static.php',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'php function-resets',
      scope: 'punctuation.definition.parameters.begin.bracket.round.php,punctuation.definition.parameters.end.bracket.round.php,punctuation.separator.delimiter.php,punctuation.section.scope.begin.php,punctuation.section.scope.end.php,punctuation.terminator.expression.php,punctuation.definition.arguments.begin.bracket.round.php,punctuation.definition.arguments.end.bracket.round.php,punctuation.definition.storage-type.begin.bracket.round.php,punctuation.definition.storage-type.end.bracket.round.php,punctuation.definition.array.begin.bracket.round.php,punctuation.definition.array.end.bracket.round.php,punctuation.definition.begin.bracket.round.php,punctuation.definition.end.bracket.round.php,punctuation.definition.begin.bracket.curly.php,punctuation.definition.end.bracket.curly.php,punctuation.definition.section.switch-block.end.bracket.curly.php,punctuation.definition.section.switch-block.start.bracket.curly.php,punctuation.definition.section.switch-block.begin.bracket.curly.php,punctuation.definition.section.switch-block.end.bracket.curly.php',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'support php constants',
      scope: 'support.constant.core.rust',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'support php constants',
      scope: 'support.constant.ext.php,support.constant.std.php,support.constant.core.php,support.constant.parser-token.php',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'php goto',
      scope: 'entity.name.goto-label.php,support.other.php',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'php logical/bitwise operator',
      scope: 'keyword.operator.logical.php,keyword.operator.bitwise.php,keyword.operator.arithmetic.php',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'php regexp operator',
      scope: 'keyword.operator.regexp.php',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'php comparison',
      scope: 'keyword.operator.comparison.php',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'php heredoc/nowdoc',
      scope: 'keyword.operator.heredoc.php,keyword.operator.nowdoc.php',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'python function decorator @',
      scope: 'meta.function.decorator.python',
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'python function support',
      scope: 'support.token.decorator.python,meta.function.decorator.identifier.python',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'parameter function js/ts',
      scope: 'function.parameter',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'brace function',
      scope: 'function.brace',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'parameter function ruby cs',
      scope: 'function.parameter.ruby, function.parameter.cs',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'constant.language.symbol.ruby',
      scope: 'constant.language.symbol.ruby',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'constant.language.symbol.hashkey.ruby',
      scope: 'constant.language.symbol.hashkey.ruby',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'rgb-value',
      scope: 'rgb-value',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'rgb value',
      scope: 'inline-color-decoration rgb-value',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'rgb value less',
      scope: 'less rgb-value',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'sass selector',
      scope: 'selector.sass',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'ts primitive/builtin types',
      scope: 'support.type.primitive.ts,support.type.builtin.ts,support.type.primitive.tsx,support.type.builtin.tsx',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'block scope',
      scope: 'block.scope.end,block.scope.begin',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'cs storage type',
      scope: 'storage.type.cs',
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'cs local variable',
      scope: 'entity.name.variable.local.cs',
      settings: {
        foreground: colorText
      }
    }, {
      scope: 'token.info-token',
      settings: {
        foreground: colorOrange
      }
    }, {
      scope: 'token.warn-token',
      settings: {
        foreground: colorGreen
      }
    }, {
      scope: 'token.error-token',
      settings: {
        foreground: colorRed
      }
    }, {
      scope: 'token.debug-token',
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'String interpolation',
      scope: ['punctuation.definition.template-expression.begin', 'punctuation.definition.template-expression.end', 'punctuation.section.embedded'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Reset JavaScript string interpolation expression',
      scope: ['meta.template.expression'],
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Import module JS',
      scope: ['keyword.operator.module'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'js Flowtype',
      scope: ['support.type.type.flowtype'],
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'js Flow',
      scope: ['support.type.primitive'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'js class prop',
      scope: ['meta.property.object'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'js func parameter',
      scope: ['variable.parameter.function.js'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'js template literals begin',
      scope: ['keyword.other.template.begin'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js template literals end',
      scope: ['keyword.other.template.end'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js template literals variable braces begin',
      scope: ['keyword.other.substitution.begin'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js template literals variable braces end',
      scope: ['keyword.other.substitution.end'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'js operator.assignment',
      scope: ['keyword.operator.assignment'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'go operator',
      scope: ['keyword.operator.assignment.go'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'go operator',
      scope: ['keyword.operator.arithmetic.go', 'keyword.operator.address.go'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Go package name',
      scope: ['entity.name.package.go'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'elm prelude',
      scope: ['support.type.prelude.elm'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'elm constant',
      scope: ['support.constant.elm'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'template literal',
      scope: ['punctuation.quasi.element'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'html/pug (jade) escaped characters and entities',
      scope: ['constant.character.entity'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'styling css pseudo-elements/classes to be able to differentiate from classes which are the same colour',
      scope: ['entity.other.attribute-name.pseudo-element', 'entity.other.attribute-name.pseudo-class'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'Clojure globals',
      scope: ['entity.global.clojure'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Clojure symbols',
      scope: ['meta.symbol.clojure'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Clojure constants',
      scope: ['constant.keyword.clojure'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'CoffeeScript Function Argument',
      scope: ['meta.arguments.coffee', 'variable.parameter.function.coffee'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Ini Default Text',
      scope: ['source.ini'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Makefile prerequisities',
      scope: ['meta.scope.prerequisites.makefile'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Makefile text colour',
      scope: ['source.makefile'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Groovy import names',
      scope: ['storage.modifier.import.groovy'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Groovy Methods',
      scope: ['meta.method.groovy'],
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'Groovy Variables',
      scope: ['meta.definition.variable.name.groovy'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Groovy Inheritance',
      scope: ['meta.definition.class.inherited.classes.groovy'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'HLSL Semantic',
      scope: ['support.variable.semantic.hlsl'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'HLSL Types',
      scope: ['support.type.texture.hlsl', 'support.type.sampler.hlsl', 'support.type.object.hlsl', 'support.type.object.rw.hlsl', 'support.type.fx.hlsl', 'support.type.object.hlsl'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'SQL Variables',
      scope: ['text.variable', 'text.bracketed'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'types',
      scope: ['support.type.swift', 'support.type.vb.asp'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'heading 1, keyword',
      scope: ['entity.name.function.xi'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'heading 2, callable',
      scope: ['entity.name.class.xi'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'heading 3, property',
      scope: ['constant.character.character-class.regexp.xi'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'heading 4, type, class, interface',
      scope: ['constant.regexp.xi'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'heading 5, enums, preprocessor, constant, decorator',
      scope: ['keyword.control.xi'],
      settings: {
        foreground: colorBlue
      }
    }, {
      name: 'heading 6, number',
      scope: ['invalid.xi'],
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'string',
      scope: ['beginning.punctuation.definition.quote.markdown.xi'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'comments',
      scope: ['beginning.punctuation.definition.list.markdown.xi'],
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'link',
      scope: ['constant.character.xi'],
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'accent',
      scope: ['accent.xi'],
      settings: {
        foreground: colorOrange
      }
    }, {
      name: 'wikiword',
      scope: ['wikiword.xi'],
      settings: {
        foreground: colorGreen
      }
    }, {
      name: "language operators like '+', '-' etc",
      scope: ['constant.other.color.rgb-value.xi'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'elements to dim',
      scope: ['punctuation.definition.tag.xi'],
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'C++/C#',
      scope: ['entity.name.label.cs', 'entity.name.scope-resolution.function.call', 'entity.name.scope-resolution.function.definition'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'Markdown underscore-style headers',
      scope: ['entity.name.label.cs', 'markup.heading.setext.1.markdown', 'markup.heading.setext.2.markdown'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'meta.brace.square',
      scope: [' meta.brace.square'],
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Comments',
      scope: 'comment, punctuation.definition.comment',
      settings: {
        foreground: colorTextTertiary,
        fontStyle: 'italic'
      }
    }, {
      name: '[VSCODE-CUSTOM] Markdown Quote',
      scope: 'markup.quote.markdown',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'punctuation.definition.block.sequence.item.yaml',
      scope: 'punctuation.definition.block.sequence.item.yaml',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      scope: ['constant.language.symbol.elixir', 'constant.language.symbol.double-quoted.elixir'],
      settings: {
        foreground: colorBlue
      }
    }, {
      scope: ['entity.name.variable.parameter.cs'],
      settings: {
        foreground: colorRed
      }
    }, {
      scope: ['entity.name.variable.field.cs'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Deleted',
      scope: 'markup.deleted',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'Inserted',
      scope: 'markup.inserted',
      settings: {
        foreground: colorGreen
      }
    }, {
      name: 'Underline',
      scope: 'markup.underline',
      settings: {
        fontStyle: 'underline'
      }
    }, {
      name: 'punctuation.section.embedded.begin.php',
      scope: ['punctuation.section.embedded.begin.php', 'punctuation.section.embedded.end.php'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'support.other.namespace.php',
      scope: ['support.other.namespace.php'],
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'variable.other.object',
      scope: ['variable.other.object'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'variable.other.constant.property',
      scope: ['variable.other.constant.property'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'entity.other.inherited-class',
      scope: ['entity.other.inherited-class'],
      settings: {
        foreground: colorRed
      }
    }, {
      name: 'c variable readwrite',
      scope: 'variable.other.readwrite.c',
      settings: {
        foreground: colorText
      }
    }, {
      name: 'php scope',
      scope: 'entity.name.variable.parameter.php,punctuation.separator.colon.php,constant.other.php',
      settings: {
        foreground: colorTextTertiary
      }
    }, {
      name: 'Assembly',
      scope: ['constant.numeric.decimal.asm.x86_64'],
      settings: {
        foreground: colorBlue
      }
    }, {
      scope: ['support.other.parenthesis.regexp'],
      settings: {
        foreground: colorGreen
      }
    }, {
      scope: ['constant.character.escape'],
      settings: {
        foreground: colorBlue
      }
    }, {
      scope: ['string.regexp'],
      settings: {
        foreground: colorText
      }
    }, {
      scope: ['log.info'],
      settings: {
        foreground: colorGreen
      }
    }, {
      scope: ['log.warning'],
      settings: {
        foreground: colorRed
      }
    }, {
      scope: ['log.error'],
      settings: {
        foreground: colorText
      }
    }, {
      name: 'js/ts italic',
      scope: 'entity.other.attribute-name.js,entity.other.attribute-name.ts,entity.other.attribute-name.jsx,entity.other.attribute-name.tsx,variable.parameter,variable.language.super',
      settings: {
        fontStyle: 'italic'
      }
    }, {
      name: 'comment',
      scope: 'comment.line.double-slash,comment.block.documentation',
      settings: {
        fontStyle: 'italic'
      }
    }, {
      name: 'Python Keyword Control',
      scope: 'keyword.control.import.python,keyword.control.flow.python,keyword.operator.logical.python',
      settings: {
        fontStyle: 'italic'
      }
    }, {
      name: 'markup.italic.markdown',
      scope: 'markup.italic.markdown',
      settings: {
        fontStyle: 'italic'
      }
    }],
    colors: {
      'editor.foreground': colorTextSecondary
    }
  };
};